import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import OwnQuestionPaperSection from "../components/questioners/create_question_paper/own_question_paper/OwnQuestionPaperSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { Container } from "react-bootstrap";

class OwnQuestionPaper extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
     if (toggled === "wrapper") {
         this.setState({toggled:"wrapper sidebar-enable"});
         Cookies.set("toggle", "wrapper sidebar-enable");
     } else {
         this.setState({toggled:"wrapper"});
         Cookies.set("toggle", "wrapper");
     }
 };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    console.log("OwnQuestionPaper", this.props.history.location.state);
    return (
      <div className={Cookies.get("toggle")}>
      <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
          
      </div>
      <div className="main-wrapper">

      <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
          <SideNavbar onClick={() => this.menuToggler()} />
      </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper" style={{ minHeight: "50vh" }}>
            <Container fluid>
            <OwnQuestionPaperSection
                locationData={this.props}
                getGroupData={this.props.history.location.state}
              />
            </Container>
                  
          </div>
          <Footer />
      </div>
  </div>

    );
  }
}

export default (OwnQuestionPaper);
